/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><from-item :isShow="(isShow)" :isRequiredShow="(isRequiredShow)" label="证件类型"><mpx-view slot="input" @tap="showTypeSelect" class="es-content__birth-data-input"><div :style='["flex:1"] | transRpxStyle'><div class="picker"><div v-if="(cardType.card_name)">{{cardType.card_name}}</div></div></div><es-icon name="angle-right" size="16" color="#999999"></es-icon></mpx-view></from-item><drawer-bottom :show="(isCardTypeShow)" @close="showTypeSelect"><div border slot="header"><div class="es-credentials__drawer-header"><div class="es-credentials__drawer-header-title">请选择证件类型</div><mpx-view @tap="showTypeSelect" class="es-credentials__drawer-header-right"><es-icon size="24" color="#999999" name="close-filled" class="es-credentials__drawer-close"></es-icon></mpx-view></div></div><div v-for="(item, index) in (cardTypeList)"><es-cell border useTitle @click="selectCardType(item)" class="es-cell-custom" :custom-class='["es-credentials__miniapp_drawer_cell"].join(" ")' v-if="(item.code != cardType.code)"><div slot="title"><span>{{item.name}}</span><span class="es-credentials__card-no" v-if="(item.display_card_no)">{{item.display_card_no}}</span></div></es-cell><es-cell border useTitle align="right" @click="showTypeSelect" class="es-cell-custom" :custom-class='["es-credentials__miniapp_drawer_cell"].join(" ")' v-else><div slot="title"><span>{{item.name}}</span><span class="es-credentials__card-no" v-if="(item.display_card_no)">{{item.display_card_no}}</span></div><es-icon name="check-filled" class="es-credentials__checked"></es-icon></es-cell></div><div :style='["height:80px;width:100%"] | transRpxStyle'/></drawer-bottom></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m61378d57"}'>
+b('content')
  +e('birth-data-input')
    display flex
    width 100%
    justify-content space-between
    align-items center
.placeholder{
  color #999999
}
+b('credentials')
    margin-bottom 16px
    /deep/ .placeholder
      color #999999 !important
    +e('type')
      display flex
    +e('type-select')
      display flex
      /deep/ .delete
        font-size 20px !important
        color #999999 !important
        padding-left 12px
    // 小程序用
    +e('miniapp_cell')
      height 54px
      color #333333
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #f0f2f7
        left 90px !important
        right 0 !important
    // 小程序用
    +e('miniapp_drawer_cell')
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #eeeeee !important
        left 0 !important
        right 0 !important
    +e('type-text')
      flex 1
      display flex
    +e('type-tag')
      color #1473ff
      border 1px solid #73ACFF
      border-radius 2px
      margin-left 4px
      display inline-block
      line-height 1
      font-size 12px
      padding 2px
      transform scale(0.83)
      align-self center
      white-space nowrap
    +e('type-change')
      color #1473FF
      font-size 12px
      display inline-block
      transform scale(0.9)
      align-self center
    +e('checked')
      color #1473ff
      font-size 20px
    +e('drawer')
      /deep/ .drawer-container
        height auto
      /deep/ .drawer-main
        height auto
    +e('drawer-content')
      display flex
      flex-direction column
    +e('drawer-footer')
      padding 16px 0
      background-color #ffffff
      /deep/ .es-button
        border-radius 8px
    +e('drawer-header')
      display flex
      height 60px
      align-items center
    +e('drawer-header-title')
      flex 1
      text-align center
      font-size 16px
      font-weight 500
      margin-left 56px
      font-family PingFangSC-Medium
    +e('drawer-header-right')
      width 56px
      text-align center
    +e('drawer-header-close')
      color #999999 !important
    +e('required-text')
      color #F93822
    +e('card-no')
      margin-left 8px
    +e('name-box')
      display flex
      width 88px
      margin-right 9px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m61378d57"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./card-type.mpx.js?isComponent&outputPath=components%2Fcard-type61378d57%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./card-type.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcard-type61378d57%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m61378d57"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/card-type61378d57/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'drawer-bottom':getComponent(require("../../drawer-bottom/index.mpx?isComponent&outputPath=components%2Findex06b5b816%2Findex")),'from-item':getComponent(require("./from-item.mpx?isComponent&outputPath=components%2Ffrom-item141a5554%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'es-field':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/field/index.mpx?isComponent&outputPath=components%2Findex69975464%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
